<template>
  <!--股权出质-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :scroll="scroll"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      scroll: { x: 1300 },
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '登记编号',
          dataIndex: 'registrationNum',
          key: 'registrationNum',
        },
        {
          title: '出质人',
          dataIndex: 'pledgor',
          key: 'pledgor',
        },
        {
          title: '出质人证件号',
          dataIndex: 'pledgorKeyNo',
          key: 'pledgorKeyNo',
        },
        {
          title: '出质股权数额',
          dataIndex: 'amount',
          key: 'amount',
        },
        {
          title: '质权人',
          dataIndex: 'pawnee',
          key: 'pawnee',
        },
        {
          title: '质权人证件号',
          dataIndex: 'pawneeKeyNo',
          key: 'pawneeKeyNo',
        },
        {
          title: '出质股权标的企业',
          dataIndex: 'relatedEnterpriseName',
          key: 'relatedEnterpriseName',
        },
        {
          title: '登记日期',
          dataIndex: 'registrationDate',
          key: 'registrationDate',
        },
        {
          title: '公示日期',
          dataIndex: 'publicityDate',
          key: 'publicityDate',
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {
    // 分页
  },
}
</script>
